module.exports = __webpack_public_path__ + "img/bio.0da11f4e.webp";